import React from "react"
import {createPortal} from "react-dom"
import Popup from "components/Popup"
import { UI_LAYER_SUPPORT_MENU } from "constants/uiLayers"
import "components/entityFieldPhotoView/EntityFieldPhotoViewerPopup.sass"

type Props = {
  open: boolean
  imageSrc: string | null
  imageAlt: string
  onClose: () => void
}

/**
 * Просмотр фото поля сущности: `Popup` + единая белая карточка UIKit v2, без «слоя серых».
 * Портал на body: сайдбар полей `position: sticky`, иначе fixed-попап клипается внутри aside.
 */
function EntityFieldPhotoViewerPopup({ open, imageSrc, imageAlt, onClose }: Props) {
  if (!open || !imageSrc) {
    return null
  }

  return createPortal(
    <Popup
      className="entity-field-photo-v2"
      onClose={onClose}
      maxWidth="100%"
      padding="0"
      background="#ffffff"
      wrapperClassName="entity-field-photo-v2__box"
      style={{ zIndex: UI_LAYER_SUPPORT_MENU + 1 }}
    >
      <div className="entity-field-photo-v2__body">
        <img
          className="entity-field-photo-v2__img"
          src={imageSrc}
          alt={imageAlt}
          loading="eager"
          decoding="async"
          draggable={false}
          data-testid="entity-field-photo-popup-img"
        />
      </div>
    </Popup>,
    document.body,
  )
}

export default EntityFieldPhotoViewerPopup
